const ASSISTANT_PROVIDERS = ['chatgpt', 'perplexity', 'claude', 'gemini'] as const;
export type AssistantProvider = typeof ASSISTANT_PROVIDERS[number];

const PROVIDER_LABELS: Record<AssistantProvider, string> = {
  chatgpt: 'ChatGPT',
  perplexity: 'Perplexity',
  claude: 'Claude',
  gemini: 'Gemini',
};

export function normalizeAssistantProvider(raw: string | undefined): AssistantProvider | undefined {
  if (!raw) return undefined;
  const v = raw.toLowerCase();
  if (v.includes('chatgpt') || v.includes('openai') || v.includes('gpt')) return 'chatgpt';
  if (v.includes('perplexity')) return 'perplexity';
  if (v.includes('claude') || v.includes('anthropic')) return 'claude';
  if (v.includes('gemini') || v.includes('google')) return 'gemini';
  return undefined;
}

export function assistantProviderLabel(provider: AssistantProvider): string {
  return PROVIDER_LABELS[provider];
}
